import { Class } from './class';

export class OrganizationAdministrator {
  AccountID: number;
  AccountName: string;
  AccountExternalID: string;
  RoleCode: string;
  RoleDescription: string;
}

export class OrganizationClassSection {
  CourseCode: string;
  CourseDescription: string;
  ClassID?: number;
  StartingOn?: string;
  Ending?: string;
}

export class Permission {
  PermissionCode: string;
}

export class OrganizationDetail {
  ID: number;
  Description: string;
  TypeCode: string;
  TypeDescription: string;
  ExternalID?: string;
  LoginCode: string;
  ParentOrganizationID?: number;
  ParentOrganizationDescription?: string;
  Administrators: OrganizationAdministrator[];
  Classes?: Class[];
  ClassSection?: OrganizationClassSection;
  IsParentOrganizationVisibleToAccount?: boolean;
  Permissions?: Permission[];
  IsValidClientSyncTarget?: boolean;
  IsCleverOrg?: boolean;
  LicensesPurchased?: number;
  RenewalDate?: string;
  APMName?: string;
  APMEmail?: string;
}

export class OrganizationStats {
  DirectClassCount: number;
  DirectStudentCount: number;
  DirectSubOrgCount: number;
  TotalClassCount: number;
  TotalStudentCount: number;
  TotalSubOrgCount: number;
}

export class OrganizationDetailAndStats extends OrganizationDetail {
  Stats: OrganizationStats;
}

export class OrganizationClassData{
  ID: number;
  ClassSectionID: number;
  Description: string;
  TeacherName: string;
  StudentCount: number;
  ActiveStudentCount: number;
  AverageMinutesInProduct: number;
  AverageUnitTestPctCorrect: number;
  TotalNumSpeakingOpportunities: number;
  AverageSparcScore: number;
  LastMonthAverageSparcScore: number;
}
